var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "notifications-panel" }, [
    _c("header", { staticClass: "notifications-header" }, [
      _c("h3", [_vm._v(_vm._s(_vm.$t("nav.notifications")))]),
      _c("span", [_vm._v(_vm._s(_vm.actionCount))])
    ]),
    _vm.actionItems && _vm.actionCount
      ? _c(
          "div",
          { staticClass: "notifications-list" },
          [
            _vm.features.projectsEnabled
              ? _c("deliverables", {
                  attrs: {
                    deliverables: _vm.actionItems.assignedTasks || [],
                    "task-mode": ""
                  },
                  on: { refresh: _vm.getActionItems }
                })
              : _vm._e(),
            _vm.features.ticketsEnabled
              ? _c("tickets", {
                  attrs: { tickets: _vm.actionItems.openTickets || [] }
                })
              : _vm._e(),
            _vm.features.projectsEnabled
              ? _c("deliverables", {
                  attrs: { deliverables: _vm.actionItems.deliverables || [] },
                  on: { refresh: _vm.getActionItems }
                })
              : _vm._e(),
            _vm.features.invoicesEnabled
              ? _c("invoices", {
                  attrs: { invoices: _vm.actionItems.invoices || [] },
                  on: { refresh: _vm.getActionItems }
                })
              : _vm._e(),
            _vm.features.formsEnabled
              ? _c("forms", {
                  attrs: { forms: _vm.actionItems.forms || [] },
                  on: { refresh: _vm.getActionItems }
                })
              : _vm._e(),
            _vm.features.proposalsEnabled
              ? _c("proposals", {
                  attrs: {
                    proposals: _vm.actionItems.proposals || [],
                    agreements: _vm.actionItems.agreements || []
                  },
                  on: { refresh: _vm.getActionItems }
                })
              : _vm._e(),
            _vm.features.meetingsEnabled
              ? _c("meetings", {
                  attrs: { meetings: _vm.actionItems.meetings || [] },
                  on: { refresh: _vm.getActionItems }
                })
              : _vm._e(),
            _vm.features.invoicesEnabled
              ? _c("subscription-requests", {
                  attrs: {
                    "subscription-requests":
                      _vm.actionItems.subscriptionRequests || []
                  },
                  on: { refresh: _vm.getActionItems }
                })
              : _vm._e()
          ],
          1
        )
      : _vm.actionItems
      ? _c("div", { staticClass: "notifications-empty" }, [
          _c(
            "span",
            [_c("portal-icon", { attrs: { name: "check", size: 22 } })],
            1
          ),
          _c("strong", [_vm._v("0 " + _vm._s(_vm.$t("nav.notifications")))])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }